<template>
  <div class="section-download-docs">
    <div class="download-card">
      <div class="footer-title" v-html="getWordings.smartpostSectionDownloadTitle"></div>
      <LinkButton
        class="link-button"
        :wordingKey="'smartpostSectionDownloadButton'"
        :hrefLink="downloadDocsURL"
        :isShowIcon="false"
        :openNewTab="true"
      />
    </div>
  </div>
</template>

<script lang="ts">
import Vue from "vue";
import { Component } from "vue-property-decorator";
import LinkButton from "@/components/controls/LinkButton.vue";
import { Getter } from "vuex-class";

@Component({
  components: {
    LinkButton
  },
  inject: ["routes"]
})
export default class SectionSmartPOSTLearnMore extends Vue {
  @Getter("text/getWordings") getWordings!: any;
  downloadDocsURL = process.env.VUE_APP_XID_DOCS_DOWNLOAD_URL as string;
}
</script>

<style lang="scss" scoped>
.section-download-docs {
  @include size(100%, auto);
  @include layoutPadding();
  @extend %centerContent;
  flex-direction: column;
  background: $gs8;
  padding-top: 0;
  padding-bottom: 100px;

  .download-card {
    @extend %centerContent;
    flex-direction: column;
    width: 100%;
    background: $white;
    border: 1px solid #dddddd;
    border-radius: $radius15;
    padding: 60px 20px;
    box-sizing: border-box;
  }

  .footer-title {
    @include titleFz(m);
    @include fw(heavy);
    line-height: 44px;
    width: 100%;
    margin-bottom: 60px;
    text-align: center;
  }

  .button-wrapper {
    @include flex(center, center);
    @include mq(m) {
      width: 100%;
    }
  }

  @include mq(l) {
    padding-bottom: 40px;

    .download-card {
      padding: 40px 20px 20px;
    }

    .footer-title {
      @include fz(l);
      line-height: normal;
      width: 100%;
      margin-bottom: 40px;
    }
  }
}
</style>
